export const CAN_SDS_ADMIN = 'SDS Admin';
export const CAN_APPS = 'CANapps';
export const CAN_DISPATCH = 'CANdispatch';
export const CAN_TRACK = 'CANtrack';
export const CAN_MAIL = 'CANmail';
export const ROUTE_CANSHARE = 'CANshare';
export const CAN_SENSE = 'CANsense';
export const CAN_WORK = 'CANwork';
export const CAN_PROSPECT = 'CANprospect';
export const CAN_WEBSITE = 'CANwebsite';
export const CAN_PARK = 'CANpark';
export const CAN_SURVEY = 'CANsurvey';

export const APP_CAN_TRACK = 'cantrackv3';
export const APP_CAN_APPS_V3 = 'canappsv3';
export const APP_CAN_APPS_V1 = 'canappsv1';
